import Icon, { ICONS } from '../../Ui/Icon'

const CARD_COLORS = ['#E8C547', '#4ADE80', '#60A5FA', '#A78BFA', '#F97316', '#F472B6']

export default function ServiceCard({ service, onEdit, onDelete, index = 0, delay = 0 }) {
  const color    = CARD_COLORS[index % CARD_COLORS.length]
  const price    = `₹${parseFloat(service.price).toLocaleString('en-IN')}`
  const duration = `${service.duration_hours} hr${service.duration_hours !== '1.0' ? 's' : ''}`

  return (
    <div className="stat-card" style={{ animationDelay: `${delay}s`, position: 'relative' }}>

      {/* ── Action buttons ── */}
      <div style={{ position: 'absolute', top: 14, right: 14, display: 'flex', gap: 6 }}>
        <button
          onClick={() => onEdit(service)}
          title="Edit"
          style={{
            width: 30, height: 30, borderRadius: 7,
            border: '1px solid var(--border-input)',
            background: 'var(--bg-input)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            cursor: 'pointer', color: 'var(--gold)', fontSize: 14,
            transition: 'all 0.2s',
          }}
          onMouseEnter={e => e.currentTarget.style.background = 'var(--bg-hover)'}
          onMouseLeave={e => e.currentTarget.style.background = 'var(--bg-input)'}
        >✎</button>

        <button
          onClick={() => onDelete(service)}
          title="Delete"
          style={{
            width: 30, height: 30, borderRadius: 7,
            border: '1px solid rgba(248,113,113,0.3)',
            background: 'rgba(248,113,113,0.08)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            cursor: 'pointer', color: '#F87171', fontSize: 14,
            transition: 'all 0.2s',
          }}
          onMouseEnter={e => e.currentTarget.style.background = 'rgba(248,113,113,0.18)'}
          onMouseLeave={e => e.currentTarget.style.background = 'rgba(248,113,113,0.08)'}
        >🗑</button>
      </div>

      {/* ── Header ── */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 14, paddingRight: 72 }}>
        <div style={{
          width: 38, height: 38, borderRadius: 10,
          background: `${color}18`, display: 'flex', alignItems: 'center',
          justifyContent: 'center', color, flexShrink: 0,
        }}>
          <Icon d={ICONS.services} size={18} />
        </div>
        <div>
          <div style={{ fontSize: 14, fontWeight: 600, color: 'var(--text-primary)', fontFamily: "'Barlow',sans-serif" }}>
            {service.name}
          </div>
          <div style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 2 }}>
            {duration}
          </div>
        </div>
      </div>

      {/* ── Price row ── */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 10 }}>
        <span style={{ fontSize: 22, fontFamily: "'Bebas Neue',sans-serif", color, letterSpacing: '0.06em' }}>
          {price}
        </span>
        <span style={{ fontSize: 11, color: 'var(--text-muted)', letterSpacing: '0.06em' }}>
          {duration}
        </span>
      </div>

      {/* ── Progress bar ── */}
      <div style={{ marginTop: 12, height: 4, borderRadius: 4, background: 'rgba(255,255,255,0.07)' }}>
        <div style={{
          height: '100%', borderRadius: 4, background: color,
          width: `${Math.min(100, (parseFloat(service.price) / 5000) * 100)}%`,
          transition: 'width 1s ease',
        }} />
      </div>

    </div>
  )
}
